var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMockSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124.326,
    height: 124.272,
    viewBox: "0 0 124.326 124.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2159",
    "data-name": "Ret\\xE2ngulo 2159",
    width: 124.326,
    height: 124.272,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098caf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-mock-sheet",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4200",
    "data-name": "Grupo 4200",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1937",
    "data-name": "Caminho 1937",
    d: "M0,69.892a7.329,7.329,0,0,0,.651-.513q13.262-13.25,26.513-26.511c.143-.143.273-.3.476-.515-.3-.32-.577-.641-.876-.94Q15.4,30.042,4.029,18.668c-4.331-4.333-4.3-9.65,0-14.02,1.706-1.724,3.5-3.267,5.979-3.686A9.236,9.236,0,0,1,18.5,3.79Q29.9,15.213,41.314,26.618c.314.314.577.675.831.979Q56.095,13.653,69.743,0c18.218,18.218,36.248,36.251,54.582,54.584a5.937,5.937,0,0,0-1.125.75Q89.208,89.3,55.24,123.285c-.308.308-.572.656-.858.986H54.14a8.293,8.293,0,0,0-.535-.639Q27.124,97.145.639,70.667c-.195-.195-.426-.358-.639-.533ZM54.256,118.5,118.48,54.281,70.027,5.813,45.117,30.724a6.877,6.877,0,0,1,1.023.73Q51.778,37.059,57.377,42.7a3.02,3.02,0,0,1,.816,1.538c.618,3.993,1.174,8,1.739,12,.195,1.376.36,2.755.552,4.237-5.68-.809-11.16-1.574-16.632-2.4a2.476,2.476,0,0,1-1.17-.777Q37.04,51.695,31.437,46.064c-.3-.3-.622-.589-.767-.728Q18.165,57.844,5.889,70.124L54.261,118.5Zm-.8-74.363a11.59,11.59,0,0,1-1.048-.841C40.52,31.456,28.564,19.68,16.79,7.717,13.416,4.291,10.1,3.781,6.556,7.829c-2.173,2.474-2.306,5.3,0,7.657q3.9,3.991,7.83,7.948,14.53,14.549,29.083,29.082c.277.277.562.533.787.742l3.214-3.095Q32.06,34.748,16.756,19.455l2.78-2.929Q34.989,31.983,50.267,47.259l3.2-3.117ZM48.636,54.791c2.483.353,4.782.675,7.221,1.026-.36-2.464-.695-4.773-1.068-7.322-2.052,2.065-3.9,3.921-5.749,5.781-.112.112-.192.242-.407.513Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1938",
    "data-name": "Caminho 1938",
    d: "M42.353,89.993c1.613,1.623,3.339,3.374,5.075,5.108,1.435,1.435,2.353,1.435,3.791,0q4.934-4.924,9.85-9.862a7.277,7.277,0,0,0,.74-1.06l2.9,2.954c-.118.133-.337.409-.583.653q-5.1,5.106-10.2,10.2c-2.924,2.9-6.323,2.88-9.263-.044-1.744-1.736-3.486-3.47-5.209-5.182.952-.91,1.842-1.761,2.89-2.764Z",
    transform: "translate(4.914 10.484)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1939",
    "data-name": "Caminho 1939",
    d: "M43.869,70.958,24.31,51.4l2.563-2.474,19.594,19.6Z",
    transform: "translate(3.028 6.094)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1940",
    "data-name": "Caminho 1940",
    d: "M18.955,56.679c.858-.851,1.716-1.7,2.446-2.425L41.09,73.945l-2.435,2.422Z",
    transform: "translate(2.361 6.757)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1941",
    "data-name": "Caminho 1941",
    d: "M35.911,79.085l-2.572,2.474L13.8,62.024c.777-.787,1.677-1.687,2.516-2.535L35.911,79.083Z",
    transform: "translate(1.719 7.409)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1942",
    "data-name": "Caminho 1942",
    d: "M75.665,25.775c-.73.7-1.627,1.556-2.422,2.313q-6.8-6.8-13.7-13.7l2.407-2.326Z",
    transform: "translate(7.416 1.502)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1943",
    "data-name": "Caminho 1943",
    d: "M70.459,31.029c-.831.787-1.707,1.615-2.474,2.336L54.254,19.633l2.407-2.4c4.575,4.572,9.139,9.135,13.8,13.794",
    transform: "translate(6.757 2.147)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1944",
    "data-name": "Caminho 1944",
    d: "M48.955,25.164c.864-.94,1.7-1.854,2.505-2.725q6.918,6.921,13.734,13.736l-2.577,2.639L48.952,25.162Z",
    transform: "translate(6.097 2.795)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1945",
    "data-name": "Caminho 1945",
    d: "M95.751,48.511l.025-.025L98.362,45.9l-.039-.037Q92.785,40.325,87.21,34.748L87.2,34.74l-2.609-2.609-.1.112L73.451,43.29l-.112.12q-1.247,1.25-2.5,2.5c.035.035.069.069.1.1L82,57.056l.412.4c.735.732,1.462,1.462,2.205,2.2l.126-.128q5.494-5.494,11.026-11.021ZM84.6,54.444,76.056,45.9l8.538-8.535L93.134,45.9Z",
    transform: "translate(8.823 4.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1946",
    "data-name": "Caminho 1946",
    d: "M79.391,64.621l.025-.025L82,62.01l-.039-.037L70.85,50.858l-.008-.008-2.609-2.609-.1.112L57.091,59.4l-.112.12q-1.247,1.25-2.5,2.5c.035.035.069.069.1.1L65.637,73.166l.412.4c.735.732,1.462,1.462,2.205,2.2l.126-.128q5.494-5.494,11.026-11.021ZM68.237,70.554,59.7,62.008l8.538-8.535,8.541,8.533Z",
    transform: "translate(6.785 6.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1947",
    "data-name": "Caminho 1947",
    d: "M62.309,81.955l.025-.025,2.586-2.586-.039-.037q-5.538-5.538-11.113-11.115l-.008-.008-2.609-2.609-.1.112L40.009,76.734l-.112.12q-1.247,1.25-2.5,2.5c.035.035.069.069.1.1L48.555,90.5l.412.4c.735.732,1.462,1.462,2.205,2.2l.126-.128q5.494-5.494,11.026-11.021ZM51.155,87.888l-8.541-8.547,8.538-8.535,8.541,8.533Z",
    transform: "translate(4.658 8.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1948",
    "data-name": "Caminho 1948",
    d: "M61.789,82.544c1.246-1.251,2.5-2.5,3.675-3.684L68.1,81.489c-1.159,1.112-2.454,2.362-3.785,3.636l-2.522-2.58Z",
    transform: "translate(7.696 9.822)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1949",
    "data-name": "Caminho 1949",
    d: "M27.563,42.264c-.3-.32-.577-.641-.876-.94Q15.319,29.953,3.952,18.578c-4.331-4.333-4.3-9.65,0-14.02C5.657,2.835,7.449,1.292,9.931.872A9.236,9.236,0,0,1,18.419,3.7q11.4,11.423,22.817,22.828c.314.314.577.675.831.979l2.972,3.126a6.877,6.877,0,0,1,1.023.73Q51.7,36.97,57.3,42.61a3.02,3.02,0,0,1,.816,1.538c.618,3.993,1.174,8,1.739,12,.195,1.376.36,2.755.552,4.237-5.68-.809-11.16-1.574-16.632-2.4a2.476,2.476,0,0,1-1.17-.777q-5.642-5.605-11.245-11.236c-.3-.3-.622-.589-.767-.728Zm25.82,1.787a11.59,11.59,0,0,1-1.048-.841C40.442,31.367,28.486,19.59,16.712,7.627,13.338,4.2,10.026,3.692,6.478,7.74c-2.173,2.474-2.306,5.3,0,7.657q3.9,3.991,7.83,7.948,14.53,14.549,29.083,29.082c.277.277.562.533.787.742l3.214-3.095Q31.982,34.659,16.678,19.366l2.78-2.929Q34.911,31.894,50.19,47.17l3.2-3.117ZM48.558,54.7c2.483.353,4.782.675,7.221,1.026-.36-2.464-.695-4.773-1.068-7.322-2.052,2.065-3.9,3.921-5.749,5.781-.112.112-.192.242-.407.513Z",
    transform: "translate(0.089 0.089)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMockSheet);
export default __webpack_public_path__ + "static/media/icon-mock-sheet.af832c93cf7837f54b52d956ade374e2.svg";
export { ForwardRef as ReactComponent };